module.exports = __webpack_public_path__ + "img/pastures_en.a9933f48.svg";